if (!customElements.get('sticky-atc-bar')) {
  function checkBarVisibility() {
    const stickyAtcBar = document.querySelector(".sticky-atc-bar");
    const productVisible = document.querySelector(".product .product__info-wrapper");
    document.addEventListener("scroll", (e) => {
      let productVisibleHeight = productVisible.offsetHeight / 2;
      let scrolled = document.scrollingElement.scrollTop;
  
      if (scrolled > productVisibleHeight) {
        stickyAtcBar.classList.add('atc-visible');
      } else {
        stickyAtcBar.classList.remove('atc-visible');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', checkBarVisibility);
  document.addEventListener('shopify:section:load', checkBarVisibility);

  const stickyAtcSelect = document.querySelector('sticky-atc-bar .select__select');
  let atcPrice = document.querySelector('sticky-atc-bar .price-item--regular');
  let atcImage = document.querySelector('sticky-atc-bar img');
  if (stickyAtcSelect) {
    stickyAtcSelect.onchange = function(){
      const getNewPrice = stickyAtcSelect.options[this.selectedIndex].getAttribute('data-price');
      atcPrice.innerHTML = getNewPrice;
      
      const getNewImage = stickyAtcSelect.options[this.selectedIndex].getAttribute('data-media');
      if ( getNewImage != null ) {
        atcImage.src = getNewImage;
      }
    };
  }
}